/* =============================================================================
File: EasyStumpOut_Header_v01.tsx
Description: ReactSetv22026BSSC header component for EasyStumpOut.
Version: v01
Date: 2026-04-14
============================================================================= */

import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import type { ILocationConfig } from "../App_CONFIG_v01a";
import { ContactPhoneNumber } from "../../00UI-Utilities/PhoneNumber_v01";
import { Telephone } from "react-bootstrap-icons/dist";

//CSS CUSTOM STYLES!
import { InlinePageStyles } from "../App_STYLES_v01a";



function EasyStumpOut_Header_v01({
  locationConfig,
}: {
  locationConfig: ILocationConfig;
}) {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <Navbar expand="lg" variant="dark" style={{ background: "var(--brand-dark)" }}>
      <Container>
        <Navbar.Brand className="fw-bold" as={Link} to="/">
          {locationConfig.logoPart1}
          <span style={{ color: "text-primary" }}>{locationConfig.logoPart2}</span>
          {locationConfig.logoPart3}{" "}&nbsp;&nbsp;

          {/* <span style={{ color: "text-primary" }}>{locationConfig.phoneNumber}</span> */}

          <span style={{ color: "text-primary" }}>
                {/* <ContactPhoneNumber
                    phoneNumberTel={locationConfig.phoneNumber}
                    phoneNumberFormatted={locationConfig.phoneNumberFormatted}
                    /> */}
                  {/* className={className} */}
                

                {/* HAD TO FORCE THE COLOR  */}

                <Telephone className="me-2"  style={{ color: "#57c785" }}/>
                {/* <a href={`tel:${locationConfig.phoneNumber}`} style={{ color: "#57c785" }}>
                    {locationConfig.phoneNumberFormatted}
                </a> */}

                  {/* NOTE: THE e.stopPropagation() is required for the tap to call action to work on mobile */}
                <a href={locationConfig.phoneHref} 
                   style={{ color: "#57c785", cursor: 'pointer', zIndex: '9999',  pointerEvents: "auto", textDecoration: "none"}}
                   onClick={(e) => {e.stopPropagation();}}
                >
                  {locationConfig.phoneNumberFormatted}
                </a>
          </span>

  

        </Navbar.Brand >

        <Navbar.Toggle aria-controls="navMain" />

        <Navbar.Collapse id="navMain">
          <Nav className="ms-auto mb-2 mb-lg-0">
            {isHome ? (
              <>
                <Nav.Link href="#services">Services</Nav.Link>
                <Nav.Link href="#process">How It Works</Nav.Link>
                
                <Nav.Link href="/airspade">Air Spade</Nav.Link>
                <Nav.Link href="/projects">Recent Projects</Nav.Link>
                
                <Nav.Link href="#pricing">Pricing</Nav.Link>
                <Nav.Link href="#faq">FAQ</Nav.Link>
                <Nav.Link href="#quote">Free Quote</Nav.Link>
              </>
            ) : (
              <Nav.Link as={Link} to="/">
                Home
              </Nav.Link>
            )}

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default EasyStumpOut_Header_v01;

/* =============================================================================
File: EasyStumpOut_Header_v01.tsx
Description: Header component for EasyStumpOut using ReactSetv22026BSSC structure.
Version: v01
Date: 2026-04-14
============================================================================= */
